import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ size, fill, altFill }) => (
  <svg viewBox="0 0 116.2 133.91" width={size}>
    <path
      fill={fill}
      d="M191.75,75.9s-5.44-4.16-10.15-2.9l.73,1.27s-10,2-12.51,10.34l2.9-.55s-4.53,10.15-11.6,9.79c.54,2.9,4.35,6,4.35,6s-4,5.08-.55,13.78c-2.72,4.53-3.8,7.79-3.44,14.86s-.73,10.34-1.27,11.24a5.5,5.5,0,0,0,2-.54,8.8,8.8,0,0,1-1.26,4.53,24.26,24.26,0,0,0,8.33-1.27c-.18,4.35,1.82,10.7,7.44,13.78.54,2,1.08,5.62.54,6.7,3.08.73,3.44-.18,3.44-.18a34.69,34.69,0,0,1,2.54,10.34,7.41,7.41,0,0,0,3.08-2.18,60.81,60.81,0,0,1,.18,7.07c6-3.44,6.89-5.62,7.8-7.25.91,4.17,2.17,11.24,12.14,14.5,6,5.62,11.24,7.43,12.69,9.24l.55-1.81s7.43-4.53,11.06-8.16l-.19,1.82s10.52-5.62,11.24-16.5c0,0,3.45,6.17,8.7,6.89a32.23,32.23,0,0,1,.73-5.8s2.17,3.08,2.54,3.63c0-4.9,2.53-11.79,2.53-11.79a12,12,0,0,0,1.64,3.27c-.19-4,3.8-9.25,5.07-12.69l-.72,2.9s6.16-7.25,5.07-14.51c1.81,1.64,6.17,1.45,9.07-.72-1.27-1.27-2.72-2.72-3.09-3.81a27.85,27.85,0,0,0,2.36,1.82,67,67,0,0,1,.18-10.52c.55-6.7-.91-13-6.71-17.4,2.9-1.81,3.81-6.16,1.46-10.88,1.63.55,3.08-1.63,4.16-3.8-1.81-.91-4.53-2.18-11.6-7.25s-11.24-6.35-14.5-6.71c-2.54-4-5.62-4.53-7.07-5.26a4.64,4.64,0,0,1,4.71,0S244.68,68.83,232.36,67c.54-.72,3.44-1.81,3.44-1.81s-11.6-4-16,4.53c-1.81-1.63-1.63-5.8,3.62-6.71-6.88-4-19.94-3.62-22.29,4.35-1.63-1.08-1.82-3.62-1.82-3.62S190.85,69.74,191.75,75.9Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M201.52,87.51s-17.58,3.08-3.08-17.23c.18,2.54,6,13.6,8.88,15,0,0-6.53-.72-9.25-5.62C198.07,79.71,197,83.7,201.52,87.51Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M212.58,85a14,14,0,0,1-10-9.61C200.07,67.2,211.13,63.21,216,64.3,209,64.3,201.16,73.73,212.58,85Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M239.77,89.68s2,.91,6.52,7.07,6.17,9.24,10.34,10l-.91-1.27a19.27,19.27,0,0,0,5.8,1.63c-1.63-1.09-2.72-2.54-5.07-6.71s-3.45-6.88-10.88-9.6a3.77,3.77,0,0,1,2,2.9S243.94,90,239.77,89.68Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M235.24,87.69s9.24-2.54,20.3,6S269,107.26,269,107.26s2.9-6.34-8.7-13.05c4.17,1.81,8,4.9,10.15,2.54-6.34-2.36-16.13-10-23.74-11.78S235.24,87.69,235.24,87.69Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M230.16,85.15s6.53-4.17,13.6-2.9c-8.34-4.71-18.31-2.54-19.76,3.26,5.07-4,9.78-3.62,9.78-3.62A34.55,34.55,0,0,0,230.16,85.15Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M216.2,85.87s3.45-9.6-1.81-17.58c-2.54.36-4,5.8-1.45,11.42S216.2,85.87,216.2,85.87Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M220.37,85.87S218.2,70.65,228,65.93a19.76,19.76,0,0,0-2.9,6.53c3.63-4.17,11.79-3.44,16.68,1.27C230.52,71.19,224,77.72,220.37,85.87Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M191.19,79l-1.27,4.53s-1.63-2.36-6-1.09a1.43,1.43,0,0,1,.72,1.45s-4.53-.91-6.16,2.54a7.54,7.54,0,0,1,3.8,0s-4.16,2-4.53,4.89a12,12,0,0,1-.36-8.7,15.25,15.25,0,0,0-2.36-.36,18.83,18.83,0,0,1,9.79-4.35V76.81A19.1,19.1,0,0,1,191.19,79Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M196.53,89.5a47.8,47.8,0,0,0-7.25,8.25c-3.35,4.71-4.35,8.24-8.7,8.61a14.16,14.16,0,0,1,.82-1.54c-3.54,2.35-4.71,2.35-5.89,2.44,3.71-2.53,4.59-9.22,9.33-12.87a23.36,23.36,0,0,1,6.35-3.62s-2.27,1.72-2.27,3.08A26.61,26.61,0,0,1,196.53,89.5Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M174.55,93.35s.23,1.45-3.85,5.21-3.4,6.57-3,9.38a13.47,13.47,0,0,1,4.8-6.43c2.95-2.31,3.85-4,3.67-5.89a6.91,6.91,0,0,1-2.36,2.58S175.28,95.35,174.55,93.35Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M173,93.22a9,9,0,0,1-6.25,2.89C168.21,98,171.07,98.15,173,93.22Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M177.46,110s-7.8,3.49-9.52,10.24c-1.72,6.43-1,10.65-3.22,13.14.73-1.95.5-4.53.59-9.79S167.35,112.25,177.46,110Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M187.52,109.94s-9.84.72-14.91,8.34c-3.9,5.84-1.23,10.37-6.94,21.39,3.13.49,6.39-4.67,6.85-5.67-.37,6.35.72,13.23,2.71,17.22,0,0-.18-7.16.64-10.15a51.13,51.13,0,0,0,2.27,10.51c1.72,4.9,2,6.17,1.81,8.25a8.16,8.16,0,0,0,1.9-4.71s2,3.53,2.81,12.6c2-2,2.54-8.89,2.54-8.89a19.45,19.45,0,0,1,.72,9.16c1.18-.18,1.27-1,1.27-1a13.41,13.41,0,0,1-.54,5.44c3.53-4.62,6.71-6.62,5.8-15.5s-3.54-12.14-2.36-19.48a14.48,14.48,0,0,0-2.35,4.07,22.76,22.76,0,0,1,0-11.51c-2.45,1.82-4.26,6.44-4.26,6.44a17.79,17.79,0,0,1,1.26-9.61c-2.62,1.27-5.16,5.08-5.43,7.07-.64-3.72,1-10.15,3.89-13.14-2.08.63-4.62,3-5.34,3.81.27-2,3.26-6.35,4.44-7.17a16.43,16.43,0,0,0-8.25,4.81C176.78,119.5,181.4,112.7,187.52,109.94Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M197.44,148.32s2.54,2,2.27,9.52.45,8,.45,8a11.46,11.46,0,0,1,2.45-3.62c-1.82,3.44-1.82,14.32,1.17,19.12-3.89-3-6.34-10.06-6.16-15.59S198,151.86,197.44,148.32Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M259.3,110s7.79,3.49,9.51,10.24c1.73,6.43,1,10.65,3.22,13.14-.72-1.95-.5-4.53-.59-9.79S269.4,112.25,259.3,110Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M249.24,109.94s9.83.72,14.91,8.34c3.89,5.84,1.22,10.37,6.93,21.39-3.13.49-6.39-4.67-6.84-5.67.36,6.35-.73,13.23-2.72,17.22,0,0,.18-7.16-.64-10.15a51.52,51.52,0,0,1-2.26,10.51c-1.72,4.9-2,6.17-1.81,8.25a8.13,8.13,0,0,1-1.91-4.71s-2,3.53-2.81,12.6c-2-2-2.54-8.89-2.54-8.89a19.45,19.45,0,0,0-.72,9.16c-1.18-.18-1.27-1-1.27-1a13.51,13.51,0,0,0,.55,5.44c-3.54-4.62-6.71-6.62-5.81-15.5s3.54-12.14,2.36-19.48a14.59,14.59,0,0,1,2.36,4.07A22.76,22.76,0,0,0,247,130c2.44,1.82,4.26,6.44,4.26,6.44a17.85,17.85,0,0,0-1.27-9.61c2.63,1.27,5.17,5.08,5.44,7.07.63-3.72-1-10.15-3.9-13.14,2.08.63,4.62,3,5.35,3.81-.28-2-3.27-6.35-4.44-7.17a16.39,16.39,0,0,1,8.24,4.81C260,119.5,255.36,112.7,249.24,109.94Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M239.31,148.32s-2.53,2-2.26,9.52-.46,8-.46,8a11.36,11.36,0,0,0-2.44-3.62c1.81,3.44,1.81,14.32-1.18,19.12,3.9-3,6.34-10.06,6.16-15.59S238.77,151.86,239.31,148.32Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M206.32,172.43a18.52,18.52,0,0,0,5.55,11.33c-.61-2.11-.68-5,.41-6.53-.07,3.61,1.77,9.38,3.47,11.36-3.6-3.27-8.16-7.28-9.31-9.66S206.32,172.43,206.32,172.43Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M220.78,188.72a44.44,44.44,0,0,0,2.92-6.25,19.9,19.9,0,0,0,.89-5s.81,2,.4,6.11a18.73,18.73,0,0,0,5.31-11c.74,2.92.47,6.66-1.5,8.91S224.25,185.73,220.78,188.72Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M200.4,107a3.56,3.56,0,0,0,2.4,2.76c1.41.45,3.36-.27,3.76-1.45a4.33,4.33,0,0,0-1.67-.23,1.3,1.3,0,0,1-1.36.55,1.36,1.36,0,0,1-1.27-1.63A11,11,0,0,0,200.4,107Zm32.83,1.63a1.29,1.29,0,0,1-1.36-.55,4.39,4.39,0,0,0-1.68.23c.41,1.18,2.36,1.9,3.76,1.45a3.54,3.54,0,0,0,2.4-2.76,10.82,10.82,0,0,0-1.85,0A1.37,1.37,0,0,1,233.23,108.67ZM243.54,112c-3.47-3.19-4.49-3.67-5.51-2.44s-2.79,1.63-4.89,1.56-3.94-.41-3.67-.13c.74.61,1.42,4.07,1.22,4.82,1.84-.34,2.65,0,3.13.75a8,8,0,0,0-4.15,1.43c-.2.13-.61-.07-.61-1.43s-.34-4.49-2-5.17c.07.55-.34,1.09-.62.82s.07-1.43-1.76-2.79-3.16-2.24-3.6-3.36-.21-2.35.54-2.28c.64.44,2.45,3.33,5.74,3.6s6.87-2.55,9-3.63,4.93-1.26,6.26.3c-1.09.92-2.48,2-2.48,2.28s0,.85,1.42.85a3.26,3.26,0,0,0,3.33-1.63c.92-1.46.75-3.78-1.83-6.39s-4.72-4.69-8.5-8.36-7.1-4.73-10.47-3.64c-2.84.92-4.11,2.92-5.78,3.09-1.68-.17-2.95-2.17-5.79-3.09-3.36-1.09-6.69,0-10.47,3.64s-5.91,5.74-8.5,8.36-2.75,4.93-1.83,6.39a3.27,3.27,0,0,0,3.33,1.63c1.43,0,1.43-.41,1.43-.85s-1.39-1.36-2.48-2.28c1.32-1.56,4.08-1.39,6.25-.3s5.75,3.9,9,3.63,5.1-3.16,5.75-3.6c.74-.07,1,1.16.54,2.28s-1.77,2-3.6,3.36-1.5,2.52-1.77,2.79-.68-.27-.61-.82c-1.63.68-2,3.81-2,5.17s-.41,1.56-.62,1.43a7.91,7.91,0,0,0-4.14-1.43c.47-.75,1.29-1.09,3.13-.75-.21-.75.47-4.21,1.22-4.82.27-.28-1.56.06-3.67.13s-3.88-.34-4.9-1.56-2-.75-5.5,2.44-3.81,6.87-2.45,8.77a31.84,31.84,0,0,0,4.22,4.35,5,5,0,0,1,.4-3.39c.89-1.91,1.23-2.72.89-3.47s-.48-2.45.34-3.06c2.17,3.47,3.06,3.67,5,4.21-3.47,2-3.54,4.49-3.54,4.49a58.74,58.74,0,0,1,6.8,2,67.13,67.13,0,0,1-6.73-.48s0,2.59.48,3,3.33,1.3,9.1,3.2c-3.12-.07-8.76-.27-8.76-.27a4.77,4.77,0,0,0,.88,1.09c.68.68,3.81,1,9.52,2.37-1.91,1.3-5.92.75-8.37.75,5.71,6.94,13.74,2.45,14.82.55s1-4.22-2-5.71-6.93-3-7.2-4.22a10,10,0,0,1,.27-3.4s1,2.45,3,1.63,2.45-2.58,4.9-2a26.85,26.85,0,0,0,7.22,0c2.45-.54,2.85,1.23,4.89,2s3-1.63,3-1.63a9.86,9.86,0,0,1,.28,3.4c-.28,1.23-4.22,2.72-7.21,4.22s-3.13,3.8-2,5.71,9.11,6.39,14.82-.55c-2.45,0-6.46.55-8.36-.75,5.71-1.35,8.84-1.69,9.51-2.37a4.69,4.69,0,0,0,.89-1.09s-5.64.2-8.77.27c5.78-1.9,8.63-2.79,9.11-3.2s.48-3,.48-3a67.41,67.41,0,0,1-6.73.48,58.26,58.26,0,0,1,6.79-2s-.06-2.51-3.53-4.49c2-.54,2.85-.74,5-4.21.81.61.68,2.31.34,3.06s0,1.56.88,3.47a5,5,0,0,1,.41,3.39,32,32,0,0,0,4.21-4.35C247.34,118.91,247,115.24,243.54,112Zm-17.29-11.21c.32-.5,3.14-3.63,6.52-4.17,2.54-.41,3.31,1.36,2.77,1.27-4.49-.41-8.84,3.31-8.84,3.31C226.47,101.33,226,101.28,226.25,100.83Zm-16.2.41s-4.35-3.72-8.83-3.31c-.55.09.22-1.68,2.76-1.27,3.39.54,6.21,3.67,6.53,4.17S210.28,101.33,210.05,101.24Zm5.53,9.74c0-.82.74-1.35,1.62-1.62a3.24,3.24,0,0,1,2.76.15,1.68,1.68,0,0,1,1.21,1.47A27,27,0,0,0,215.58,111Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M211.31,125.37a4.63,4.63,0,0,1,2.78.2,11.47,11.47,0,0,0,4.36,1.19v-1.83a8.37,8.37,0,0,1-2.72-.45C214,124,212.46,124,211.31,125.37Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M225.45,125.37a4.66,4.66,0,0,0-2.79.2,11.42,11.42,0,0,1-4.35,1.19v-1.83a8.4,8.4,0,0,0,2.72-.45C222.74,124,224.29,124,225.45,125.37Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M213.16,139.53a3,3,0,0,0,.41,3.13,3.56,3.56,0,0,1,.54-1.5s2.45-.09,5.71,0v-1.86A28,28,0,0,0,213.16,139.53Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M223.59,139.53a3,3,0,0,1-.41,3.13,3.4,3.4,0,0,0-.54-1.5s-2.45-.09-5.71,0v-1.86A28,28,0,0,1,223.59,139.53Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M206.6,140.57s2.22-.09,2.58.37a15.52,15.52,0,0,0,1.45,5.61C208.46,146.24,205.65,142.43,206.6,140.57Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M230.16,140.57s-2.22-.09-2.59.37a15.11,15.11,0,0,1-1.45,5.61C228.3,146.24,231.11,142.43,230.16,140.57Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M212.23,155.28a5.43,5.43,0,0,1-2.38,1.22c-1.15.14-1.9-1.15-1.56-5.85A16.66,16.66,0,0,0,212.23,155.28Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M224.52,155.28a5.5,5.5,0,0,0,2.38,1.22c1.16.14,1.9-1.15,1.56-5.85A16.33,16.33,0,0,1,224.52,155.28Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M213,155.11a11.4,11.4,0,0,0,1.56-.1c0-.82-.3-1.3-.94-1.24S213,154.84,213,155.11Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M222.18,155.11a11.4,11.4,0,0,0,1.56-.1c0-.82-.3-1.3-.94-1.24S222.18,154.84,222.18,155.11Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M215.22,155h1.09s.15-.92-.51-.92S215.19,154.6,215.22,155Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M216.79,155h1.08s.14-.88-.51-.92S216.75,154.6,216.79,155Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M219,155h1.09s.14-.92-.51-.92S219,154.6,219,155Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M220.58,155h1.09s.14-.88-.51-.92S220.55,154.6,220.58,155Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M206.37,159s-.23,1.63,1.95,1.76,3.44-.86,5.89-2a8.34,8.34,0,0,1,6.62-.72c2.53.68,6.39,3.17,8.38,2.76s1.31-1.67,1.31-1.67.5-.46.68.36a12.24,12.24,0,0,1-.95,6.84,8.19,8.19,0,0,1-5.12,4,2.24,2.24,0,0,0-.45-1.18,9.49,9.49,0,0,1-6,3.26,8.28,8.28,0,0,1-6.34-3.35c-.5.18-.46.95-.41,1.13-1.41.36-4.53-1.14-5.76-4.67a11.7,11.7,0,0,1-.45-6.52C205.92,158.34,206.37,158.43,206.37,159Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={fill}
      d="M237.59,109.14l11.7.06a2.25,2.25,0,0,1,2.33,2.51c1.54.09,2.73.15,1.21,3.48-1.05,2.11-2.12,1.92-3.31,2.17-4.16,8.35-6.75,12.51-11.65,12.62C229,115.44,237.59,109.14,237.59,109.14Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={fill}
      d="M196.82,129.63c-3.95.16-7.48-6.62-10-12.56-2.15-.23-2.91-1.2-3.48-3.14-.69-2.34.25-2.9,1.71-2.79-.47-1.41.57-1.92,1.48-1.88s10.94,0,10.94,0h3.34c1,0,1.53,1,2.58,1s2.81-1,3.75-1h1.34c2.91,0,3.75.43,5.5,1.68s2.83,2.42,4.66,2.33c1.67-.08,4.09-3.91,6.5-3.91h4.67l7.08,20.91a46.67,46.67,0,0,0-5.41.25c-4,.34-8,0-9.59-3.08s-1.83-8.92-3.16-9.33-1.59,1.33-2.25,3.83-2.75,8.25-8.75,8.17-10.5-.59-10.5-.59l-.36.11"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M187.78,110.26s20.29.06,22.87.17,3.84,1.38,5.24,2.36a4.1,4.1,0,0,0,3.38.79l.37,3.32a2.77,2.77,0,0,0-3.89,2.29c-.64,3.55-1.85,10.39-6.92,10.89-6.56.66-12.09-.06-13.47-.84-2.39-1.32-4-4.94-7.43-12.35-2.24-.72-2.9-1-3.44-3.14s.41-1.91,1.7-1.85C186,110.85,186.37,110.22,187.78,110.26Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={fill}
      d="M186.37,114s-.58-1.11.08-1.18.94.63,1.31,1.83S187,115.75,186.37,114Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M249.05,110.57s-20.17-.17-22.75-.09-3.93,1.34-5.38,2.3a5.12,5.12,0,0,1-3.83.75l-.17,3.4s3.25-1.31,3.75,2.25,1.29,10.41,6.32,11c6.49.76,12,.13,13.42-.64,2.44-1.29,4.27-4.9,8.07-12.31,2.26-.69,2.94-1,3.6-3.1s-.28-1.93-1.56-1.89C250.82,111.18,250.45,110.55,249.05,110.57Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={fill}
      d="M250.21,114.33s.65-1.11,0-1.19-1,.62-1.42,1.82S249.49,116.09,250.21,114.33Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={fill}
      d="M193.3,112.38s10.81,0,14.84.51,5.63,1,6,4.26-.23,9.29-1.65,10.49-4,1.74-12.36,1.09c-4.58-.41-5-1.69-6.28-4.3s-3.07-7.83-3.39-8.79S190.19,112.61,193.3,112.38Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={fill}
      d="M244.26,112.21s-10.7,0-14.69.5-5.58,1-5.94,4.21.23,9.21,1.63,10.39,4,1.72,12.25,1.08c4.53-.4,5-1.67,6.21-4.26s3.59-7.73,3.91-8.68S247.35,112.43,244.26,112.21Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M211.39,113s-6.84-.55-10-.67c-8.5-.33-10.5,4.83-9.34,8.17a48.32,48.32,0,0,0,3,7s-5.33-9-5.66-13.67c.16-2,2.16-2.67,6.16-2.5s10.5.33,10.5.33Z"
      transform="translate(-160.21 -60.55)"
    />
    <path
      fill={altFill}
      d="M237.39,112s-1,.16-4.5.33-9.67,5-9.17,9.83c-.17,1.17-2-4.66-2-6.33s3.08-3.68,6.21-3.84S237.39,112,237.39,112Z"
      transform="translate(-160.21 -60.55)"
    />
    <polygon fill={altFill} points="40.84 52.49 43.17 52.49 34.01 61.66 40.84 52.49" />
    <polygon fill={altFill} points="46.34 53.16 49.34 53.32 36.01 65.32 46.34 53.16" />
    <polygon fill={altFill} points="73.84 53.16 66.68 62.99 76.51 53.16 73.84 53.16" />
    <polygon fill={altFill} points="80.01 53.16 68.34 67.32 83.01 53.16 80.01 53.16" />
  </svg>
);

Logo.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  fill: PropTypes.string.isRequired,
  altFill: PropTypes.string,
};

Logo.defaultProps = {
  altFill: 'white',
};

export default Logo;
